import apiConfig from "../../apiConfig";

export const setDonationBandStatus = async (at, donationBandId, statusId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/DONATIONS_BANDS/Set_Donation_Band_Status",
		{
			Donation_Band_Id: donationBandId,
			Active_Status_Id: statusId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
